import type { QueryRequest, QueryResponse } from '@cognite/sdk';
import { type UseSuspenseQueryOptions, useSuspenseQuery } from '@tanstack/react-query';

import { useCogniteClient } from '#core/hooks/useCogniteClient.ts';

export function useInstanceQuery<const OutputType>(
  query: QueryRequest,
  select?: (data: QueryResponse | null) => OutputType,
  options: Partial<
    UseSuspenseQueryOptions<
      QueryResponse,
      Error,
      OutputType,
      readonly [
        'fusionInstanceQuery',
        {
          data: {
            query: QueryRequest;
          };
        },
      ]
    >
  > = {},
) {
  const client = useCogniteClient();

  return useSuspenseQuery({
    queryKey: ['fusionInstanceQuery', { data: { query } }] as const,
    queryFn: async ({ queryKey: [, { data }] }) => client?.instances.query(data.query),
    select,
    ...options,
  });
}
